import React, { useEffect, useState } from "react";

//---------libraries---------------//
import {
  Button,
  Space,
  Table,
  Tag,
  Tooltip,
  Switch,
  message,
  Dropdown,
  Menu,
  Pagination,
} from "antd";
import {
  AiOutlineDelete,
  AiOutlineTeam,
  AiOutlineEdit,
  AiOutlineArrowUp,
} from "react-icons/ai";

import "./Assistant.css";
import { IoIosCheckmarkCircle } from "react-icons/io";
//-----Helper----------//
import {
  showDeleteConfirm,
  redirectToAssistant,
} from "../../Utility/assistant-helper";

//Components
import AssistantTeamAssignModal from "./AssistantTeamAssignModal";
import DebouncedSearchInput from "../../Pages/SuperAdmin/Organizations/DebouncedSearchInput";
import {
  handleSwitchChange,
  showRemoveConfirm,
} from "../../Utility/showModalHelper";
import { AssistantNeedToActiveFirst } from "../../constants/PublicAndPrivateAssistantMessages";
import { handleCheckAssistantActive } from "../../Utility/addPublicAssistantHelper";
import { useContext } from "react";
import { FileContext } from "../../contexts/FileContext";
import { useNavigate } from "react-router-dom";
import { IoChatbubbleEllipsesOutline, IoCloseCircle } from "react-icons/io5";
import { BiSolidLock, BiSolidLockOpen } from "react-icons/bi";
import { BsRobot, BsThreeDotsVertical } from "react-icons/bs";
import { RxCrossCircled } from "react-icons/rx";
import { CiCircleCheck } from "react-icons/ci";
import ProfileHeader from "../Proflie/ProfileHeader";
const AssistantTable = ({ data }) => {
  const {
    assistants,
    setAssistants,
    loader,
    teamList,
    handleAssignTeamToAssistant,
    handleDeleteAssistant,
    handleUpdateAssistant,
    showEditModalHandler,
    handleFetchAllAssistants,
    updateLoader,
    searchOrganizationalAssistants,
    orgAssistantSearchQuery,
    setOrgAssistantSearchQuery,
    handlePublicAssistantAdd,
    getAssistantInfo,
  } = data;
  const [selectedAssistant, setSelectedAssistant] = useState(null);
  const [searchQuery, setSearchQuery] = useState("");
  const { isEditPageLoading, setIsEditPageLoading } = useContext(FileContext);
  const [pageSize, setPageSize] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const navigate = useNavigate();

  useEffect(() => {
    handleFetchAllAssistants(currentPage, orgAssistantSearchQuery, pageSize);
  }, [currentPage, pageSize]);

  //Local function
  const handleViewTeams = (team) => {
    setSelectedAssistant(team);
  };

  const redirectToAssistant = (record) => {
    const assistantId = record.assistant_id;
    const url = `/agents/${assistantId}`;
    window.open(url, "_blank");
  };

  const createActionMenu = (record) => {
    return (
      <Menu>
        {
          <Menu.Item key="chat">
            <span
              style={{ display: "flex", alignItems: "center", gap: "8px" }}
              onClick={() => redirectToAssistant(record)}
            >
              <IoChatbubbleEllipsesOutline /> Chat with Agent
            </span>
          </Menu.Item>
        }
        {
          <Menu.Item key="edit">
            <span
              style={{ display: "flex", alignItems: "center", gap: "8px" }}
              onClick={async () => {
                setIsEditPageLoading(true);
                const isExisting = await getAssistantInfo(record?.assistant_id);
                if (isExisting) {
                  await showEditModalHandler(record);
                } else {
                  setIsEditPageLoading(false);
                }
              }}
            >
              <AiOutlineEdit /> Edit
            </span>
          </Menu.Item>
        }

        {
          <Menu.Item key="status">
            <span
              style={{ display: "flex", alignItems: "center", gap: "8px" }}
              onClick={async () => {
                await handleSwitchChange(
                  record,
                  !record?.is_active,
                  handleUpdateAssistant
                );

                handleFetchAllAssistants(
                  currentPage,
                  orgAssistantSearchQuery,
                  pageSize
                );
              }}
            >
              {record?.is_active ? <RxCrossCircled /> : <CiCircleCheck />}
              {record?.is_active ? "Make Deactivate" : "Make Activate"}
            </span>
          </Menu.Item>
        }
        {
          <Menu.Item key="viewTeams">
            <span
              style={{ display: "flex", alignItems: "center", gap: "8px" }}
              onClick={() => handleViewTeams(record)}
            >
              <AiOutlineTeam /> View Teams
            </span>
          </Menu.Item>
        }
        {
          <Menu.Item key="publicPrivate">
            <span
              style={{ display: "flex", alignItems: "center", gap: "8px" }}
              onClick={async () => {
                await handleCheckAssistantActive(
                  !record?.is_public,
                  record,
                  handlePublicAssistantAdd
                );
                handleFetchAllAssistants(
                  currentPage,
                  orgAssistantSearchQuery,
                  pageSize
                );
              }}
            >
              {record?.is_public ? <BiSolidLock /> : <BiSolidLockOpen />}
              {record?.is_public ? "Make Private" : "Make Public"}
            </span>
          </Menu.Item>
        }
        {
          <Menu.Item key="delete" danger>
            <span
              style={{ display: "flex", alignItems: "center", gap: "8px" }}
              onClick={async () => {
                await showDeleteConfirm(
                  record?.assistant_id,
                  record?.name,
                  handleDeleteAssistant
                );
                handleFetchAllAssistants(
                  currentPage,
                  orgAssistantSearchQuery,
                  pageSize
                );
              }}
            >
              <AiOutlineDelete /> Delete
            </span>
          </Menu.Item>
        }
      </Menu>
    );
  };

  //column
  const columns = [
    {
      title: "Agent",
      dataIndex: "name",
      key: "name",
      align: "left",
      render: (_, { name, image_url }) => (
        <Space size="middle" className="d-flex align-items-center">
          <div className="assistantImageDiv">
            {image_url ? (
              <img src={image_url} className="customImage" alt="avatar" />
            ) : (
              <BsRobot className="customImage" />
            )}
          </div>
          <div className="ms-2 text-start">{name}</div>
        </Space>
      ),
    },
    {
      title: "Created by",
      dataIndex: "userId",
      key: "userId",
      align: "center",
      render: (user) => <span className="text-left">{user?.fname}</span>,
    },
    {
      title: "Teams",
      key: "teamId",
      align: "center",
      dataIndex: "teamId",
      render: (_, { teamId: teams }) => (
        <div className="d-flex align-items-center flex-wrap gap-1">
          {(teams || [])?.map((team) => {
            return (
              <Tag color="geekblue" key={team._id}>
                {team.teamTitle.toUpperCase()}
              </Tag>
            );
          })}
        </div>
      ),
    },
    {
      title: "Status",
      key: "is_active",
      align: "center",
      dataIndex: "is_active",
      width: 100,
      render: (_, { is_active }) => (
        <Tag color={is_active ? "green" : "red"}>
          {is_active ? "active" : "inactive"}
        </Tag>
      ),
    },
    {
      title: "Action",
      key: "action",
      align: "center",
      width: "10%",

      render: (_, record) => (
        <Space size="middle">
          <Dropdown overlay={createActionMenu(record)} trigger={["click"]}>
            <a onClick={(e) => e.preventDefault()}>
              <Space>
                <BsThreeDotsVertical />
              </Space>
            </a>
          </Dropdown>
        </Space>
      ),
    },
  ];

  return (
    <>
      <AssistantTeamAssignModal
        data={{
          selectedAssistant,
          setSelectedAssistant,
          teamList,
          handleAssignTeamToAssistant,
          isTeamAssigning: loader.ASSISTANT_UPDATING,
        }}
      />

      <div className="mb-1">
        <ProfileHeader
          title="Organizational Agents"
          subHeading="Collaborate with AI agents within the organization."
        />
        <div className="searchbox-container">
          <div className="searchbox-wrapper">
            <DebouncedSearchInput
              data={{
                search: orgAssistantSearchQuery,
                setSearch: setOrgAssistantSearchQuery,
                placeholder: "Search Organizational Agents",
              }}
            />
          </div>
          <Pagination
            current={currentPage}
            pageSize={pageSize}
            total={assistants?.meta?.total}
            showSizeChanger={true}
            onShowSizeChange={(current, size) => {
              setPageSize(size);
              setCurrentPage(1);
            }}
            onChange={(page) => setCurrentPage(page)}
            showTotal={(total, range) =>
              `${range[0]}-${range[1]} of ${total} items`
            }
          />
        </div>
      </div>
      <Table
        loading={loader.ALL_ASSISTANT_LOADING || isEditPageLoading}
        columns={columns}
        dataSource={assistants.assistants}
        scroll={{ y: "50vh" }}
        className={`${
          loader.ALL_ASSISTANT_LOADING ||
          isEditPageLoading ||
          assistants?.assistants?.length === 0
            ? "mt-3"
            : ""
        }`}
        pagination={false}
      />
    </>
  );
};

export default AssistantTable;
